import script from "./Lokationsfilter.vue?vue&type=script&setup=true&lang=ts"
export * from "./Lokationsfilter.vue?vue&type=script&setup=true&lang=ts"

export default script